import { FulfillmentMethod } from '@biteinc/enums';

export function getClassForFulfillmentMethod(
  fulfillmentMethod: FulfillmentMethod,
): 'curbside' | 'delivery' | 'dine-in' | 'outpost' | 'to-go' {
  switch (fulfillmentMethod) {
    case FulfillmentMethod.CATERING_CURBSIDE:
    case FulfillmentMethod.FLASH_CURBSIDE:
    case FulfillmentMethod.LINEBUSTER_CURBSIDE:
    case FulfillmentMethod.WEB_CURBSIDE:
      return 'curbside';
    case FulfillmentMethod.CATERING_DELIVERY:
    case FulfillmentMethod.FLASH_DELIVERY:
    case FulfillmentMethod.WEB_DELIVERY:
      return 'delivery';
    case FulfillmentMethod.CATERING_DINE_IN:
    case FulfillmentMethod.FLASH_DINE_IN:
    case FulfillmentMethod.KIOSK_DINE_IN:
    case FulfillmentMethod.LINEBUSTER_DINE_IN:
    case FulfillmentMethod.WEB_DINE_IN:
      return 'dine-in';
    case FulfillmentMethod.CATERING_OUTPOST:
    case FulfillmentMethod.FLASH_OUTPOST:
    case FulfillmentMethod.KIOSK_OUTPOST:
    case FulfillmentMethod.WEB_OUTPOST:
      return 'outpost';
    case FulfillmentMethod.CATERING_TO_GO:
    case FulfillmentMethod.DRIVE_THRU_TO_GO:
    case FulfillmentMethod.FLASH_TO_GO:
    case FulfillmentMethod.KIOSK_TO_GO:
    case FulfillmentMethod.LINEBUSTER_TO_GO:
    case FulfillmentMethod.WEB_TO_GO:
      return 'to-go';
  }
}
